import React, { useCallback } from 'react'
import { Image, ImageBackground, StyleSheet } from 'react-native'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { Button, SH2, Stack, XStack } from '@zet/design-system'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'
import { DEVICE_WIDTH } from '@zet/utils/Constants'
import { navigateTo } from '@zet/utils/navigation'
import { LinearGradient } from 'expo-linear-gradient'
import { styled } from 'nativewind'

import { sbmCrossSellImages } from '../../utils/constants'

const LinearGradientStyled = styled(LinearGradient, 'h-0.5 w-1/4')

interface IProps {
  sectionTitle: string
}

const SbmCrossSell: React.FC<IProps> = ({ sectionTitle }) => {
  const handleKnowMore = useCallback(() => {
    navigateTo('MagnetBenefits')
  }, [])

  const gradientProps = {
    start: { x: 0, y: 0 },
    end: { x: 1, y: 1 },
    locations: [0, 1],
  }

  if (APP_NAME === MY_TEAMS_ADVISOR) {
    return <></>
  }
  return (
    <Stack className="bg-white">
      {sectionTitle ? (
        <XStack className="items-center justify-between bg-white p-2">
          <LinearGradientStyled
            {...gradientProps}
            colors={['#FFFFFF', '#5E9FFF']}
            style={styles.gradientWidth}
          />
          <SH2 className="text-primary-150 mx-2">{sectionTitle}</SH2>
          <LinearGradientStyled
            {...gradientProps}
            colors={['#5E9FFF', '#FFFFFF']}
            style={styles.gradientWidth}
          />
        </XStack>
      ) : null}
      <ImageBackground
        source={{
          uri: sbmCrossSellImages.bgImg,
        }}
        style={styles.bgImgcontainer}
        borderRadius={10}
      >
        <Stack style={styles.img1}>
          <Image
            source={{
              uri: sbmCrossSellImages.hookLine,
            }}
            className="h-full w-full items-center justify-end"
            resizeMode="contain"
          />
        </Stack>
        <Stack style={styles.img2}>
          <Image
            source={{
              uri: sbmCrossSellImages.approvalImg,
            }}
            className="h-full w-full items-center"
            resizeMode="contain"
          />
        </Stack>
        <Stack style={styles.img3}>
          <Image
            source={{
              uri: sbmCrossSellImages.sbmIllustration,
            }}
            className="h-full w-full items-center"
            resizeMode="contain"
          />
        </Stack>
        <Stack style={styles.btnContainer}>
          <Button
            onPress={handleKnowMore}
            textStyle={'text-white'}
            className={'bg-decorative-coolPurple150 w-full'}
          >
            {i18n.t('knowMore')}
          </Button>
        </Stack>
      </ImageBackground>
    </Stack>
  )
}

export default SbmCrossSell

const styles = StyleSheet.create({
  gradientWidth: {
    width: '15%',
  },
  bgImgcontainer: {
    alignItems: 'center',
    margin: 15,
  },
  img1: {
    width: '90%',
    height: 110,
  },
  img2: {
    width: '85%',
    height: 30,
  },
  img3: {
    width: '80%',
    height: DEVICE_WIDTH * 0.45,
    marginVertical: 16,
  },
  btnContainer: {
    width: DEVICE_WIDTH * 0.83,
    marginBottom: 16,
  },
})
